export let props = ['search', 'type']
export let model = {}
export let computed = {}
